// extracted by mini-css-extract-plugin
module.exports = {"component":"styles_component__3MbF7","left":"styles_left__1fFQS","right":"styles_right__3uEOK","title":"styles_title__2FyQu"};